module.exports = __webpack_public_path__ + "media/assets/icons/room-card-48cd210fd15e299e2c135f105b5afd27.svg";